import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {
  Selector,
  SetState,
  BidListAction,
  bidListReducer,
  ToggleVehicle,
  ToggleAllVehicles,
  UnToggleAllVehicles
} from './bid-list-reducer';
import {map, scan, shareReplay, tap} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {BidListState} from '../../interfaces/bid-list.interface';
import {BidListToggleState, ClearAllSelectedBidListVehicles} from 'remarketing-angular-library';

@Injectable({
  providedIn: 'root'
})
export class BidListToggleService {
  private _hasCheckboxActionOverridingScroll = false;

  static readonly BIDLIST_MULTI_REMOVE_LIMIT = 50;

  set hasCheckboxActionOverridingScroll(value: boolean) {
    this._hasCheckboxActionOverridingScroll = value;
  }

  get hasCheckboxActionOverridingScroll() {
    return this._hasCheckboxActionOverridingScroll;
  }

  public makeSelectAllCheckboxActive: Subject<boolean> = new Subject<boolean>();

  private readonly currentBidListState = new BehaviorSubject<BidListState>(undefined);
  private static readonly initialState: BidListState = {
    selectedVehicles: [],
    selectAll: false
  };

  bidListAction = new BehaviorSubject<BidListAction>(new SetState(BidListToggleService.initialState));

  readonly bidListState$: Observable<BidListState> = this.bidListAction.asObservable().pipe(
    scan(bidListReducer, undefined),
    tap((state: BidListState) => this.currentBidListState.next(state)),
    shareReplay(1)
  );


  constructor(
    private readonly _store: Store
  ) {
    this.bidListState$.subscribe();
  }

  select<T>(selectFn: Selector<T>): Observable<T> {
    return this.bidListState$.pipe(map(selectFn));
  }

  uncheckSelectAllCheckbox(): void {
    this.makeSelectAllCheckboxActive.next(false);
  }

  checkSelectAllCheckbox() {
    this.makeSelectAllCheckboxActive.next(true);
  }

  get getSelectAll() {
    return this.currentBidListState.getValue().selectAll;
  }

  updateTheSelectAllStatus() {
    const value = this._store.selectSnapshot(BidListToggleState.selectAll);
    if (!value) {
      this.uncheckSelectAllCheckbox();
    } else {
      this.checkSelectAllCheckbox();
    }
  }

  synchronizeSelectAll() {
    const value = this._store.selectSnapshot(BidListToggleState.selectAll);
    if (value) {
      this.uncheckSelectAllCheckbox();
    } else {
      this.checkSelectAllCheckbox();
    }
  }

  vehicleToggle(vehicle: string) {
    this.bidListAction.next(new ToggleVehicle(vehicle));
  }

  multipleVehicleToggle(vehicles: string[]) {
    this.bidListAction.next(new ToggleAllVehicles(vehicles));
  }

  multipleVehicleUnToggle(vehicles: string[]) {
    this.bidListAction.next(new UnToggleAllVehicles(vehicles));
  }

  snapShot() {
    return this.currentBidListState.getValue();
  }

  setState(state: BidListState) {
    this.bidListAction.next(new SetState(state));
  }

  reset() {
    const initialState: BidListState = {
      selectedVehicles: [],
      selectAll: false
    };
    this.uncheckSelectAllCheckbox();
    this.bidListAction.next(new SetState(initialState));
    this._store.dispatch(new ClearAllSelectedBidListVehicles());
  }
}
